import type { RefObject } from 'react'

import { useEffect } from 'react'

/** Closes a popover on outside click or Escape. Listeners are attached only while open. */
export function useDismiss(ref: RefObject<HTMLElement | null>, open: boolean, onClose: () => void) {
    useEffect(() => {
        if (!open) return

        const handlePointer = (event: MouseEvent | TouchEvent) => {
            const target = event.target as Node | null

            if (ref.current && target && !ref.current.contains(target)) onClose()
        }

        const handleKey = (event: KeyboardEvent) => {
            if (event.key === 'Escape') onClose()
        }

        document.addEventListener('mousedown', handlePointer)
        document.addEventListener('touchstart', handlePointer)
        document.addEventListener('keydown', handleKey)

        return () => {
            document.removeEventListener('mousedown', handlePointer)
            document.removeEventListener('touchstart', handlePointer)
            document.removeEventListener('keydown', handleKey)
        }
    }, [ref, open, onClose])
}
